/**
 * Shock (_choc) engagement range in meters — matches Capacite_Choc.RangeGRU in game data.
 */
export const SHOCK_TRAIT_RANGE_M = 350;
